import React, {Component} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {Button, Panel} from '../common';
import TreasureChestRedeemModal from './TreasureChestRedeemModal';
import TreasureChestContent from './TreasureChestContent';

export default class TreasureChest extends Component {
  static propTypes = {
    treasures: PropTypes.shape({
      hasMore: PropTypes.bool.isRequired,
      list: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    }).isRequired,
    onTreasuresQuery: PropTypes.func.isRequired,
    onTreasureChestRedeem: PropTypes.func.isRequired,
    sidebarToggle: PropTypes.func.isRequired,
    user: PropTypes.shape({
      coins: PropTypes.shape({
        gold: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };

  static getDerivedStateFromProps(nextProps) {
    const {isTreasureRedeeming} = nextProps;
    // TODO: Get rid of undefined value here
    if (isTreasureRedeeming === undefined) {
      return null;
    }

    return {isModalOpened: Boolean(isTreasureRedeeming)};
  }

  state = {
    isModalOpened: false,
    currentTreasure: {},
  };

  renderCurrentUserPoints = () => {
    const {
      user: {coins: {gold = 0}},
    } = this.props;

    return (
      <span className="treasure-page__sidebar-actions">
        <div className="text-center text-xxxx-big text-light">
          Your YakGold:&nbsp;
          <b>{gold}</b>
        </div>
        <Button
          size="l"
          icon="bars"
          className="top-menu-btn"
          handler={this.onSidebarToggle}
        />
      </span>
    );
  };

  onSidebarToggle = () => {
    const {sidebarToggle} = this.props;

    sidebarToggle({status: true});
  };

  onTreasureSelect = (currentTreasure) => {
    this.setState({
      isModalOpened: true,
      currentTreasure,
    });
  };

  onModalClose = () => {
    this.setState({
      isModalOpened: false,
      currentTreasure: {},
    });
  };

  redeemTreasure = (id) => {
    const {onTreasureChestRedeem} = this.props;
    onTreasureChestRedeem(id);
    this.onModalClose();
  };

  render() {
    const {
      onTreasuresQuery,
      user: {coins: {gold = 0}},
    } = this.props;
    const {isModalOpened, currentTreasure} = this.state;

    return (
      <div>
        <Panel
          title="Treasure Chest"
          subtitle="Select a treasure to redeem."
          renderActions={this.renderCurrentUserPoints()}
          size="l"
          headerSize="l"
          cls="treasure-page"
        >
          <TreasureChestContent
            onTreasuresQuery={onTreasuresQuery}
            onTreasureSelect={this.onTreasureSelect}
            {...this.props}
          />
        </Panel>
        {!isEmpty(currentTreasure) && (
          <TreasureChestRedeemModal
            isModalOpened={isModalOpened}
            onModalClose={this.onModalClose}
            onTreasureChestRedeem={this.redeemTreasure}
            availablePoints={gold}
            {...currentTreasure}
          />
        )}
      </div>
    );
  }
}
